(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-preferences-control"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-wostore-cookie-preferences]');
      if (!trigger) return;
      if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
        privacyBanner.showPreferences();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
